<template>
  <div class="add-icon" v-if="show">
    <div class="dialog-bottom row">
      <div class="dialog-down"></div>
      <span class="ml20">请点击</span>
      <span>
        <img class="img" :src="Icon" />
      </span>
      <span>
        然后点击
        <span class="ml20">“ 添加到主屏幕 ”</span>
      </span>
    </div>
    <div class="dialog-mask" @click="show=false"></div>
  </div>
</template>

<script>
import Icon from '@/assets/img/icon-20.png'
export default {
  name: 'isoHome',
  data () {
    return {
      Icon: Icon,
      show: false
    }
  },
  methods: {
    isIos () {
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      return isIOS
    },
    standalone () {
      if ('standalone' in navigator && !navigator.standalone && (/iphone|ipod|ipad/gi).test(navigator.platform) && (/Safari/i).test(navigator.appVersion)) {
        return true
      }
      return false
    }
  },
  created () {
    const standalone = this.standalone()
    const isIos = this.isIos()
    if (isIos) {
      if (!standalone) {
        this.show = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
